export const EmailNew = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 25H4C3.44772 25 3 24.5523 3 24V8C3 7.44772 3.44772 7 4 7H28C28.5523 7 29 7.44772 29 8V18" stroke="currentColor" stroke-width="2"/>
<path d="M29 7L16.0574 15.9603C16.0229 15.9841 15.9772 15.984 15.9429 15.9598L3.20758 7" stroke="currentColor" stroke-width="2"/>
<circle cx="26" cy="24" r="3.5" fill="currentColor" stroke="currentColor"/>
</svg>`;
